import axios from 'axios';
import { normalizeLegacyBarState } from '../models/legacyPreferenceBar';

const defaultClient = axios.create({ baseURL: process.env.VUE_APP_API || '', withCredentials: true, timeout: 60000 });
const url = '/stockchart/api/preference-bar';

// Bar-only choices of the account: default chips hidden, extra chips shown.
export async function loadLegacyBarState(client = defaultClient) {
  const { data } = await client.get(url);
  return normalizeLegacyBarState(data);
}

export async function saveLegacyBarState(state, client = defaultClient) {
  const clean = normalizeLegacyBarState(state), params = new URLSearchParams();
  params.append('hidden', JSON.stringify(clean.hidden));
  params.append('shown', JSON.stringify(clean.shown));
  const { data } = await client.post(url, params);
  return normalizeLegacyBarState(data);
}
